<template>
<div class="contrast" :style="{'margin-top': is_share ? '0' : '.3rem' }">
  <p class="title" v-if="cItem.hide_title == 0 && !is_share"><img :src="static_img_url + 'mobile/pic/tct_icon.png'" />{{cItem.title}}</p>
  <div class="contrast-summary" v-html="cItem.summary" v-if="!is_share"></div>
  <div class="contrast-nav" v-if="!is_share">
    <div v-for="item, index in cItem.content.x" :key="index"><div class="icon"></div>{{item | dealNeed(annotationTag)}}</div>
  </div>
  <div style="position: relative; overflow: hidden; min-height: 1.2rem">
    <div style="width: 0; height: 0; overflow: hidden;">
      <div class="contrast-content" :id="'shareImg' + cItem.id" v-show="!imgbase">
        <div class="contrast-head">
          <div class="head-1" v-if="cItem.time_show_type == 0">地区/年</div>
          <div class="head-1" v-if="cItem.time_show_type == 1">地区/季度</div>
          <div class="head-1" v-if="cItem.time_show_type == 2">地区/月</div>
          <div class="head-2">
            <div
              class="head-item"
              v-for="year_item,year_index in years_axis"
              :key="year_index"
            >
              <span>{{year_item | tct_time_list(cItem.time_show_type)}}</span>
            </div>
          </div>
        </div>
        <div class="contrast-list">
          <div class="contrast-li" v-for="item in cItem.content.y" :key="item">
            <div class="label-tag">{{item | dealNeed(address)}}</div>
            <div class="label-data">
              <div
                class="year-item"
                v-for="year_item,year_index in years_axis"
                :key="year_index"
              >
                <div>
                  <div
                    class="data-item"
                    v-for="item2,index in cItem.content.x"
                    :key="index2"
                  >
                    <span
                      v-for="item3 in cItem.content.res"
                      v-if="item3.tag_id == item2 && item3.address_id == item && time_bollen(item3, year_item)"
                      style="width: 30px"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img :src="imgbase" :preview="cItem.id" v-show="imgbase" class="imgbase"/>
    <div class="loading_img" v-if="!imgbase">
      <div class="con"><span class="loader-box"></span><br><p>图片生成中</p></div>
    </div>
  </div>
  <div class="share-area" v-if="!is_share">
    <p>数据来源：{{cItem.src_name | empty('动脉橙产业智库')}}</p>
    <div class="right">
      <span>分享至</span>
      <div @click="handleClickShare">
        <i class="iconfont">&#xe641;</i>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import html2canvas from 'html2canvas'
export default {
  props: ['cItem', 'uid', 'annotationTag', 'address'],
  data() {
    return {
      imgbase: ''
    }
  },
  computed: {
    static_img_url() {
      return this.$store.state.static_img_url
    },
    years_axis() {
      let arr = [],
          start_year = this.cItem.start_time ? moment(this.cItem.start_time).year() : 2010,
          end_year = this.cItem.end_time ? moment(this.cItem.end_time).year() : moment().year(),
          start_quarter = this.cItem.start_time ? moment(this.cItem.start_time).quarter() : 1,
          end_quarter = this.cItem.end_time ? moment(this.cItem.end_time).quarter() : moment().quarter(),
          start_month = this.cItem.start_time ? moment(this.cItem.start_time).month() + 1 : 1,
          end_month = this.cItem.end_time ? moment(this.cItem.end_time).month() + 1 : moment().month() + 1
      for (var i = start_year; i <= end_year; i++) {
        if (this.cItem.time_show_type == 0) {
          arr.push(i)
        } else if (this.cItem.time_show_type == 1){
          if (i == start_year && i != end_year) {
            for (var j = start_quarter; j <= 4; j++) {
              arr.push(i+'Q'+j)
            }
          } else if (i == end_year && i != start_year) {
            for (var j = 1; j <= end_quarter; j++) {
              arr.push(i+'Q'+j)
            }
          } else if (i == start_year && i == end_year) {
            for (var j = start_quarter; j <= end_quarter; j++) {
              arr.push(i+'Q'+j)
            }
          } else {
            for (var j = 1; j <= 4; j++) {
              arr.push(i+'Q'+j)
            }
          }
        } else if (this.cItem.time_show_type == 2){
          if (i == start_year && i != end_year) {
            for (var j = start_month; j <= 12; j++) {
              arr.push(i+'.'+j)
            }
          } else if (i == end_year && i != start_year) {
            for (var j = 1; j <= end_month; j++) {
              arr.push(i+'.'+j)
            }
          } else if (i == start_year && i == end_year) {
            for (var j = start_month; j <= end_month; j++) {
              arr.push(i+'.'+j)
            }
          } else {
            for (var j = 1; j <= 12; j++) {
              arr.push(i+'.'+j)
            }
          }
        }
      }
      return arr
    },
    time_bollen() {
      return function(item, t) {
        if (this.cItem.time_show_type == 0) {
          return item.year == t
        } else if (this.cItem.time_show_type == 1) {
          return item.year == t.split('Q')[0] && item.quarter == t.split('Q')[1]
        } else if (this.cItem.time_show_type == 2) {
          return item.year == t.split('.')[0] && item.month == t.split('.')[1]
        }
      }
    },
    is_share() {
      return this.$route.name == 'MShareScatter' || this.$route.name == 'MShareScatterWx'
    }
  },
  methods: {
    handleClickShare() {
      this.$router.push({name: 'MShareScatter', query: { tct_id: this.cItem.id,  theme_uid: this.uid}})
    }
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        html2canvas(document.getElementById('shareImg'+this.cItem.id),{ scale: 2 }).then((canvas) => {
          let save_url= canvas.toDataURL("image/png")
          this.$set(this.$data, 'imgbase', save_url)
          if(this.is_share) {
            this.$emit('greatImg', true)
          }
          this.$previewRefresh()
        })
      }, 200)
    })
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~mobile/styles/constrast.stylus'
@import '~mobile/styles/shareLoading.stylus'
.contrast
  &-nav
    > div
      &:nth-of-type(1)
        .icon
          background-color: #E96350
      &:nth-of-type(2)
        .icon
          background-color: #FFCB6A
      &:nth-of-type(3)
        .icon
          background-color: #A6D911
      &:nth-of-type(4)
        .icon
          background-color: #36CFC9
      &:nth-of-type(5)
        .icon
          background-color: #40A9FF
      &:nth-of-type(6)
        .icon
          background-color: #F88C52
      &:nth-of-type(7)
        .icon
          background-color: #FFCCBC
      &:nth-of-type(8)
        .icon
          background-color: #53C419
      &:nth-of-type(9)
        .icon
          background-color: #1EA69B
      &:nth-of-type(10)
        .icon
          background-color: #2F54EB
  &-li .label-data .year-item .data-item
    &:nth-of-type(1)
      span
        background-color: #E96350
    &:nth-of-type(2)
      span
        background-color: #FFCB6A
    &:nth-of-type(3)
      span
        background-color: #A6D911
    &:nth-of-type(4)
      span
        background-color: #36CFC9
    &:nth-of-type(5)
      span
        background-color: #40A9FF
    &:nth-of-type(6)
      span
        background-color: #F88C52
    &:nth-of-type(7)
      span
        background-color: #FFCCBC
    &:nth-of-type(8)
      span
        background-color: #53C419
    &:nth-of-type(9)
      span
        background-color: #1EA69B
    &:nth-of-type(10)
      span
        background-color: #2F54EB
</style>
